import { render, staticRenderFns } from "./Wapper.vue?vue&type=template&id=71ab7cee&scoped=true"
import script from "./Wapper.vue?vue&type=script&lang=js"
export * from "./Wapper.vue?vue&type=script&lang=js"
import style0 from "./Wapper.vue?vue&type=style&index=0&id=71ab7cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ab7cee",
  null
  
)

export default component.exports